var React = require('react');

function Nl (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd","strokeWidth":"1pt","transform":"scale(1.25 .9375)"},[React.createElement("rect",{"width":"512","height":"509.8","fill":"#fff","rx":"0","ry":"0","key":0}),React.createElement("rect",{"width":"512","height":"169.9","y":"342.1","fill":"#21468b","rx":"0","ry":"0","key":1}),React.createElement("path",{"fill":"#ae1c28","d":"M0 0h512v170H0z","key":2})]));
}

Nl.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Nl;

Nl.default = Nl;
